export const getDesigns = state => state.designs;
